import { createReducer, requestStatus, snakeToCamel } from '../../lib/Utils'
import {
  GET_CAMPAIGN_TAGS_FULFILLED,
  GET_CAMPAIGNS_FULFILLED,
  GET_CAMPAIGN,
  GET_CAMPAIGN_FULFILLED,
  GET_CAMPAIGN_REJECTED,
} from './actions'
import { UPDATE_ASSET_FULFILLED } from '../assets/actions'

const initialState = {
  campaigns: {},
}

export const GENERIC_ERROR_MSG = 'Request failed'

export default createReducer(initialState, {
  [UPDATE_ASSET_FULFILLED]: (state, action) => {
    const asset = action.payload.response
    let campaignId = null
    let campaign = null
    Object.keys(state.campaigns.byCampaignId).forEach((id) => {
      if (state.campaigns.byCampaignId[id].campaign.id === asset.campaign_id) {
        campaign = { ...state.campaigns.byCampaignId[id].campaign }
        campaignId = id
      }
    })
    if (campaign) {
      let assets = [...campaign.assets]
      let index = -1
      campaign.assets.forEach((existingAsset, i) => {
        if (existingAsset.id === asset.id) {
          index = i
        }
      })
      if (index >= 0) {
        campaign.assets[index] = { ...assets[index], ...asset }

        let campaigns = { ...state.campaigns }
        let byCampaignId = { ...(campaigns.byCampaignId || {}) }
        byCampaignId[campaignId] = {
          campaign,
          getStatus: requestStatus.complete,
        }
        campaigns.byCampaignId = byCampaignId

        return { ...state, campaigns }
      }
    }
    return state
  },
  [GET_CAMPAIGN_TAGS_FULFILLED]: (state, action) => {
    const tags = action.payload.response
    return { ...state, tags }
  },
  [GET_CAMPAIGNS_FULFILLED]: (state, action) => {
    const byType = snakeToCamel(`by_${action.payload.resourceType}`)
    const byTypeKey = action.payload.resourceId

    let campaigns = { ...state.campaigns }
    let byTypeObject = { ...(campaigns[byType] || {}) }
    byTypeObject[byTypeKey] = action.payload.response
    campaigns[byType] = byTypeObject

    return { ...state, campaigns }
  },
  [GET_CAMPAIGN]: (state, action) => {
    const campaignId = action.payload.campaignId

    let campaigns = { ...state.campaigns }
    let byCampaignId = { ...(campaigns['byCampaignId'] || {}) }
    byCampaignId[campaignId] = {
      ...(byCampaignId[campaignId] || {}),
      getStatus: requestStatus.pending,
    }
    campaigns['byCampaignId'] = byCampaignId

    return { ...state, campaigns }
  },
  [GET_CAMPAIGN_FULFILLED]: (state, action) => {
    const campaignId = action.meta.campaignId

    let campaigns = { ...state.campaigns }
    let byCampaignId = { ...(campaigns['byCampaignId'] || {}) }
    byCampaignId[campaignId] = {
      getStatus: requestStatus.complete,
      campaign: action.payload.response,
    }
    campaigns['byCampaignId'] = byCampaignId

    return { ...state, campaigns }
  },
  [GET_CAMPAIGN_REJECTED]: (state, action) => {
    if (action.payload instanceof Error) {
      return state
    }

    const campaignId = action.meta.campaignId

    let getErrors
    if (action.payload && action.payload.errors) {
      getErrors = action.payload.errors
    } else {
      getErrors = [GENERIC_ERROR_MSG]
    }

    let campaigns = { ...state.campaigns }
    let byCampaignId = { ...(campaigns['byCampaignId'] || {}) }
    byCampaignId[campaignId] = {
      campaign: null,
      getErrors,
      getStatus: requestStatus.rejected,
    }
    campaigns['byCampaignId'] = byCampaignId

    return { ...state, campaigns }
  },
})
